import { render, staticRenderFns } from "./TableViewPage.vue?vue&type=template&id=5217d1e4"
import script from "./TableViewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TableViewPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TableViewPage.vue?vue&type=style&index=0&id=5217d1e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QTooltip});
